import React from 'react';
import { Route } from '../Routing/types';
import {
  DietSettingsWeight,
  DietSettingsDietMode,
  DietSettingsGoalWeight,
  DietSettingsDietType,
  DietSettingsActivityLevel,
  DietSettingsSpontaneousActivityLevel,
  DietSettingsSex,
  DietSettingsHeight,
  DietSettingsDateOfBirth,
  DietSettingsAllSummary,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/sex',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsSex />,
  },
  {
    path: '/birth-date',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDateOfBirth />,
  },
  {
    path: '/height',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsHeight />,
  },
  {
    path: '/weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsWeight />,
  },
  {
    path: '/diet-mode',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietMode />,
  },
  {
    path: '/goal-weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsGoalWeight />,
  },
  {
    path: '/spontaneous-activity-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsSpontaneousActivityLevel />,
  },
  {
    path: '/activity-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsActivityLevel />,
  },
  {
    path: '/diet-type',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietType />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsAllSummary />,
  },
];

export default descendantRoutes;
